import Skeleton from '@mui/material/Skeleton';
import { Stack } from 'shared/mui/Stack/Stack';

export const ProvidersEditSkeleton: React.FC = () => (
  <Stack gap={2} pt={4}>
    <Skeleton height={40} variant="rounded" width="130px" />
    <Stack direction="row" gap={3} pt={1}>
      {Array.from({ length: 2 }).map((_, i) => (
        <Skeleton height={40} key={i} variant="rounded" width="100%" />
      ))}
    </Stack>
    <Skeleton height={40} variant="rounded" width="100%" />
    <Stack direction="row" justifyContent="space-between">
      <Skeleton height={36} variant="rounded" width={100} />
      <Stack direction="row" gap={2}>
        <Skeleton height={36} variant="rounded" width={108} />
        <Skeleton height={36} variant="rounded" width={116} />
      </Stack>
    </Stack>
  </Stack>
);
